/* imods parts collection (SPEC §9): list filter, case picker (dims, never removes), "Fits your iPod", row add to cart. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var root = $('[data-imods-pf]'); if (!root) return;
    var I = window.imods || {};
    var fam = root.getAttribute('data-family');
    var groups = $$('[data-group]', root);
    var list = $('[data-imods-partlist]', root);
    var heading = $('[data-imods-rows-heading]', root), countEl = $('[data-imods-rows-count]', root);
    var baseHeading = heading ? heading.textContent : '';
    var baseCount = countEl ? countEl.textContent : '';

    // QA route (test theme only): the empty state
    if (I.state === 'empty') { var e = $('[data-imods-empty]', root); if (e) e.hidden = false; groups.forEach(function (g) { g.hidden = true; }); }

    // shop-by-part list: filters the rows (links still jump to the group without JavaScript)
    function filter(key, focus) {
      groups.forEach(function (g) { g.hidden = key !== 'all' && g.getAttribute('data-group') !== key; });
      $$('a[data-filter]', list).forEach(function (a) { if (a.getAttribute('data-filter') === key) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      var g = key === 'all' ? null : $('[data-group="' + key + '"]', root);
      if (heading) heading.textContent = g ? $('h3', g).firstChild.textContent.trim() : baseHeading;
      if (countEl) countEl.textContent = g ? g.getAttribute('data-count') + (g.getAttribute('data-count') === '1' ? ' part' : ' parts') : baseCount;
      if (focus) { var t = heading || g; var top = (t.closest('.im-pf__rows') || t).getBoundingClientRect().top + scrollY - 120; if (Math.abs(top - scrollY) > 40) scrollTo({ top: top, behavior: 'smooth' }); }
    }
    if (list) list.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-filter]'); if (!a) return;
      e.preventDefault(); filter(a.getAttribute('data-filter'), true);
      try { history.replaceState(null, '', a.getAttribute('data-filter') === 'all' ? location.pathname + location.search : '#part-' + a.getAttribute('data-filter')); } catch (err) {}
    });
    var h = location.hash.replace('#', '');
    if (/^part-/.test(h)) filter(h.replace('part-', ''), false);

    // case picker: dim rows that do not fit, with their reason; persist in #case= and sessionStorage
    var picker = $('[data-imods-casepicker]', root);
    function applyCase(c) {
      $$('[data-imods-row]', root).forEach(function (r) {
        var rc = r.getAttribute('data-case');
        var dim = c && rc !== 'both' && rc !== c;
        r.classList.toggle('is-dim', !!dim);
        var reason = $('[data-dim-reason]', r); if (reason) reason.hidden = !dim;
      });
      var all = $('[data-imods-showall]', root); if (all) all.hidden = !c;
      markFits();
    }
    function readCase() {
      var m = /case=(thin|thick)/.exec(location.hash); if (m) return m[1];
      try { return sessionStorage.getItem('imods.case.' + fam); } catch (e) { return null; }
    }
    if (picker) {
      var c0 = readCase();
      if (c0) { var r0 = $('input[value="' + c0 + '"]', picker); if (r0) { r0.checked = true; applyCase(c0); } }
      picker.addEventListener('change', function (e) {
        var c = e.target.value; applyCase(c);
        try { sessionStorage.setItem('imods.case.' + fam, c); } catch (err) {}
        try { history.replaceState(null, '', location.pathname + location.search + '#case=' + c); } catch (err) {}
      });
      var all = $('[data-imods-showall]', root);
      if (all) all.addEventListener('click', function () {
        $$('input', picker).forEach(function (i) { i.checked = false; });
        try { sessionStorage.removeItem('imods.case.' + fam); } catch (err) {}
        applyCase(null);
      });
    }

    // "Fits your iPod" (D-11 A: remembered for this visit only)
    function markFits() {
      var y = I.yours && I.yours.get ? I.yours.get() : null;
      var mine = y && y.key === fam;
      // G-12: the mark is added here, only on the rows that need it, instead of a hidden copy in every row's markup
      $$('[data-imods-row]', root).forEach(function (r) {
        var want = mine && !r.classList.contains('is-dim'), f = $('[data-fits]', r);
        if (want && !f) { var meta = $('.im-row__meta', r); if (meta) meta.insertAdjacentHTML('beforeend', '<span class="im-row__fits" data-fits><svg class="im-ico" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Fits your iPod</span>'); }
        else if (f) f.hidden = !want;
      });
    }
    if (I.yours && fam) { var y = I.yours.get(); if (!y) { /* browsing a model's parts page is not a claim that the visitor owns it */ } }
    document.addEventListener('imods:yours', markFits);
    markFits();

    // row "Add part": Ajax add with Dawn's cart notification; the plain form post works without JavaScript
    root.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-imods-rowadd]'); if (!f) return;
      e.preventDefault();
      var b = $('button', f); if (b._busy) return; b._busy = true; b.setAttribute('aria-busy', 'true');
      var id = +$('input[name="id"]', f).value;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble', sections_url: location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Not added'); return j; }); })
        .then(function (j) { var cn = document.querySelector('cart-notification'); if (cn && cn.renderContents) cn.renderContents(j); })
        .catch(function (err) { var p = document.createElement('p'); p.className = 'im-note im-note--error'; p.setAttribute('role', 'alert'); p.textContent = 'This part was not added: ' + err.message; f.after(p); setTimeout(function () { p.remove(); }, 8000); })
        .then(function () { b._busy = false; b.removeAttribute('aria-busy'); });
    });
  });
})();
